import { Box } from "@mui/material";
import { useEffect, useState } from "react";
import { ToastContent } from "../../../../shared/components";
import { LoadingComp } from "../../../../shared/components/loading/Loading";
import { useDebounce, useToast } from "../../../../shared/hooks";
import { ISetup } from "../../../../shared/services/api/financial/FinancialService";
import { FinancialService } from "../../../../shared/services/api/financial/FinancialService";
import { TableSetupFees } from "../TableSetup";
import { SetupToolbar } from "../ToolbarSetup";

export const SetupFeeTab = () => {
	const { debounce } = useDebounce();
	const toastHandler = useToast();

	const [textSearch, setTextSearch] = useState("");
	const [dataIni, setDataIni] = useState("");
	const [dataFim, setDataFim] = useState("");
	const [status, setStatus] = useState("todos");
	const [paymentMethod, setPaymentMethod] = useState("todos");
	const [page, setPage] = useState(0);
	const [rowsPerPage, setRowsPerPage] = useState(10);
	const [totalCount, setTotalCount] = useState(0);
	const [setupData, setSetupData] = useState<ISetup[]>([]);
	const [isLoading, setIsLoading] = useState(false);

	const [clientId, setClientId] = useState("");

	// Transforma status "todos" e "open" conforme necessário
	const normalizeStatus = (rawStatus: string) => {
		if (rawStatus === "todos") return "";
		if (rawStatus === "open") return "pending";
		return rawStatus;
	};

	const handleFetchData = (currentPage: number, limit: number, search: string, ini: string, fim: string, stat: string, payment: string, clientId: string) => {
		setIsLoading(true);
		const finalStatus = normalizeStatus(stat);

		debounce(() => {
			FinancialService.getSetupList(search, currentPage + 1, limit.toString(), finalStatus, ini, fim, payment, clientId)
				.then((response) => {
					if (response instanceof Error) {
						toastHandler.present({
							type: "error",
							position: "top-right",
							messageOrContent: <ToastContent title="Erro" content="Erro ao buscar taxas de setup" />,
						});
					} else {
						setSetupData(response.data);
						setTotalCount(response.totalCount ?? 0);
					}
				})
				.finally(() => setIsLoading(false));
		});
	};

	useEffect(() => {
		const defaultDataIni = new Date(new Date().getFullYear(), new Date().getMonth(), 1).toISOString().split("T")[0];
		const defaultDataFim = new Date(new Date().getFullYear(), new Date().getMonth() + 1, 0).toISOString().split("T")[0];

		setTextSearch("");
		setDataIni(defaultDataIni);
		setDataFim(defaultDataFim);
		setStatus("todos");
		setPaymentMethod("todos");
		setClientId("");
		setPage(0);

		handleFetchData(0, rowsPerPage, "", defaultDataIni, defaultDataFim, "todos", "todos", "");
	}, []);

	const handleSearch = () => {
		setPage(0);
		handleFetchData(0, rowsPerPage, textSearch, dataIni, dataFim, status, paymentMethod, clientId);
	};

	const handleChangePage = (newPage: number) => {
		setPage(newPage);
		handleFetchData(newPage, rowsPerPage, textSearch, dataIni, dataFim, status, paymentMethod, clientId);
	};

	const handleChangeRowsPerPage = (newRowsPerPage: number) => {
		setRowsPerPage(newRowsPerPage);
		setPage(0);
		handleFetchData(0, newRowsPerPage, textSearch, dataIni, dataFim, status, paymentMethod, clientId);
	};

	const handleRefresh = () => {
		handleFetchData(page, rowsPerPage, textSearch, dataIni, dataFim, status, paymentMethod, clientId);
	};

	return (
		<Box>
			<SetupToolbar
				showInputSearch
				showDateRange
				showStatusSelect
				textSearch={textSearch}
				onChangeTextSearch={setTextSearch}
				onClearTextSearch={() => setTextSearch("")}
				onChangeDateStart={setDataIni}
				onChangeDateEnd={setDataFim}
				onChangeStatus={setStatus}
				onClickRefresh={handleSearch}
				onChangePaymentMethod={setPaymentMethod}
				showPaymentMethodsSelect
				showClientSelect={true}
				onChangeClient={(id) => setClientId(id || "")}
			/>

			<LoadingComp isopen={isLoading} />

			<TableSetupFees
				rows={setupData}
				page={page}
				rowsPerPage={rowsPerPage}
				totalCount={totalCount}
				onPageChange={handleChangePage}
				onRowsPerPageChange={handleChangeRowsPerPage}
				dataIni={dataIni}
				dataFim={dataFim}
				onRefresh={handleRefresh}
			/>
		</Box>
	);
};
